export const PASSWORD_MIN_LENGTH = 12
export const PASSWORD_MAX_LENGTH = 128

// Length-only policy per NIST 800-63B: no composition rules. Lengths use JS
// UTF-16 code units so the web check matches exactly; the 128 max is an abuse
// guard, while bcrypt separately truncates input at 72 bytes in @base-app/identity.
export function isPasswordPolicyCompliant(password: string): boolean {
  return password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH
}
